import PageWorking from '@pages/page-working.js';

const MatchResult = (props) => {


    return (
        <>
            <PageWorking />
        </>
    );
}  
export default MatchResult;